<template>
  <h1>项目详情</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>